// Web build runs purely in the browser (and inside the Expo WebView, which
// behaves as a normal browser). There is no Capacitor runtime anymore, so this
// is always the web path. Native capability now lives in the separate Expo
// project at /mobile-app (see /documents/MOBILE_APP_EXPO_EAS.md).
export const isNative = () => false;
export const getPlatform = () => 'web';
